export default {"src":"/_next/static/media/AMC.d426369c.svg","height":18,"width":18};